module.exports = __webpack_public_path__ + "media/fun/fun-8-7715be14.jpg";